export default __webpack_public_path__ + "static/media/kotoba_avatar.281ad9bb.png";